module.exports = __webpack_public_path__ + "img/config4.e2f83595.png";